import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

function useDoorShoeColorSelector() {
  const addToQuote = useStore((state) => state.addToQuote);
  const doorShoeColor = useStore((state) => state.quote.doorShoeColor);
  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const handleClick = (label: string) => {
    const checked = checkMark(label);

    addToQuote(
      {
        doorShoeColor: !checked ? label : "",
      },
      "doorShoeColor"
    );

    if (!checked && findRequired("Door Shoe Color"))
      removeRequired("Door Shoe Color");
  };

  const variant = (label: string) =>
    label === doorShoeColor? "filled" : "outlined";

  const checkMark = (label: string) => label === doorShoeColor;

  return {
    checkMark,
    variant,
    handleClick
  };
}

export default useDoorShoeColorSelector;
